export class EnumApiLive {
    constructor() {
        /**
         * @dec 获取直播间登录用户信息
         * @method get
         */
        this.live_user = {
            url: '/api/gateway/live-reception/public/live/authorized/user',
            method: 'get',
        };
        /**
         * @dec 查询产品列表
         * @method get
         */
        this.live_product_list = {
            url: '/api/gateway/live-reception/public/activity/product/list',
            method: 'get',
        };
        /**
         * @dec 查询视频流是否可用
         * @method get
         */
        this.live_streaming_notice = {
            url: '/api/gateway/live-reception/public/live/streaming/notice',
            method: 'get',
            loading: false,
        };
        /**
         * @dec 获取直播间属性信息
         * @method get
         */
        this.live_attribute = {
            url: '/api/gateway/live-reception/public/live/manage/attribute',
            method: 'get',
        };
        /**
         * @dec 二维码
         * @method get
         */
        this.live_qrCode = {
            url: '/api/gateway/live-reception/public/live/qrcode',
            method: 'get',
            responseType: 'blob',
        };
        /**
         * @dec 获取直播间文档下载地址
         * @method get
         */
        this.live_download_list = {
            url: '/api/gateway/live-reception/public/live/manage/doc/download',
            method: 'get',
        };
        /**
         * @dec 验证是否有权限进入直播间
         * @method get
         */
        this.live_check_auth = {
            url: '/api/gateway/live-reception/public/live/obtain/check/auth',
            method: 'get',
        };
        /**
         * @dec 存储抽奖信息
         * @method post
         */
        this.live_lottery_save = {
            url: '/api/gateway/live-reception/public/live/lottery/save',
            method: 'post',
        };
        /**
         * @dec 查询是否参与过本次抽奖
         * @method post
         */
        this.live_lottery_single = {
            url: '/api/gateway/live-reception/public/live/lottery/single/check/join',
            method: 'post',
        };
        /**
         * @dec 查询是否参与过本次直播的抽奖
         * @method post
         */
        this.live_lottery = {
            url: '/api/gateway/live-reception/public/live/lottery/check/join',
            method: 'post',
        };
        /**
         * @dec 存储参与调查问卷信息
         * @method post
         */
        this.live_questionnaire_save = {
            url: '/api/gateway/live-reception/public/live/questionnaire/save',
            method: 'post',
        };
        /**
         * @dec 查询是否参与此调查问卷
         * @method post
         */
        this.live_questionnaire_check = {
            url: '/api/gateway/live-reception/public/live/questionnaire/check/join',
            method: 'post',
        };
        /**
         * @dec ppt下载
         * @method get
         */
        this.live_ppt_down = {
            url: '/fos/tools/file/share/{id}',
            method: 'get',
        };
        /**
         * @dec 用户触发点赞
         * @method post
         */
        this.live_kudos_trigger = {
            url: '/api/gateway/live-reception/public/live/kudos/trigger',
            method: 'post',
            loading: false,
        };
        /**
         * @dec 用户查询直播间点赞数
         * @method get
         */
        this.live_kudos_search = {
            url: '/api/gateway/live-reception/public/live/kudos/search',
            method: 'get',
            loading: false,
        };
        /**
         * @dec 获取直播间来源
         * @method get
         */
        this.live_source = {
            url: '/api/gateway/live-reception/public/get/live/source',
            method: 'get',
        };
        /**
         * @dec 获取直播间权限（渠道大会）
         * @method get
         */
        this.live_auto_user = {
            url: '/api/gateway/live-reception/public/live/auto/user',
            method: 'get',
        };
        /**
         * @dec 获取直播间文字表情包（渠道大会）
         * @method get
         */
        this.live_emoji_find = {
            url: '/api/gateway/live-reception/public/live/emoji/find',
            method: 'get',
            fos: true,
        };
    }
}
